import "./shared/styles/main.scss";
import {
  useLocation,
  useNavigate,
  matchRoutes,
  BrowserRouter,
  Routes,
  Route,
} from "react-router";
import { routes } from ".";
import React, { useEffect } from "react";
import NotImplemented from "./pages/NotImplemented/NotImplemented";

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Проверяем, существует ли маршрут для текущего пути
    const matchedRoutes = matchRoutes(routes, location.pathname);

    if (!matchedRoutes) {
      alert("Такой страницы не существует!");
      navigate(-1); // Возврат на предыдущую страницу
    }

  }, [location.pathname, navigate]);

  return (
    <Routes>
      {routes.map((route, index) => (
        <Route key={index} path={route.path} element={route.element} />
      ))}
      <Route path="*" element={<NotImplemented />}></Route>
    </Routes>
  );
}

export default App;
